export enum CompilerActionTypes {
    API_RESPONSE_SUCCESS = '@@compiler/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@compiler/API_RESPONSE_ERROR',

    ADMIN_VIEW_LANGUAGES = '@@compiler/ADMIN_VIEW_LANGUAGES',
    ADMIN_VIEW_LOGS = '@@compiler/ADMIN_VIEW_LOGS',
    ADMIN_TEST_SOURCE = '@@compiler/ADMIN_VIEW_ALL_SHORT',
    ADMIN_TEST_PROBLEM = '@@compiler/ADMIN_TEST_PROBLEM',
}
